import { Spine } from '@esotericsoftware/spine-pixi-v7'
import * as PIXI from 'pixi.js';
import { globalData } from './globalData';
import { config } from './appConfig';
import { gameAssets } from './gameUI';
import { playChickenFall, PlayChickenSplat, playCrateCrash, playJeepneyHonking, playJeepReactionPhew2, playJeepReactionUmPaa, playJeepReactionWoohoo, playJeepReactionYiepie, playJeepReactionYii, playOldMan2, playPotHole1, playTrafficConeCrash, playTurtleCrash } from './soundManager';
export class obstacles {
    //testObstacles = ["L", "R", "R", "L", "R", "L", "L", "L", "R", "L", "R", "L"]
    obstaclesContainer = null
    potholeContainer = null
    obstacle = null
    potHoles = null
    nearMiss = null
    nearMiss2 = null
    lX = null
    rX = null

    idleAnimations = ["ball_idle", "cone_idle", "crate_idle", "turtle_idle", "pot_hole_1_idle", "pot_hole_2_idle", "pot_hole_3_idle"]
    hitAnimations = ["ball_hit", "cone_hit", "crate_destroy", "turtle_hit"]
    chickenAnimations = ["Chicken_wait", "Chicken_splat"]
    potHoleAnimation = ["pot_hole_1", "pot_hole_2", "pot_hole_3"]
    nearMissAnimation = ["ball_idle", "cone_idle", "crate_idle"]
    autoPlayWinAnimations = ["_side_umpaaah", "_side_wheew", "_side_wohoo_1", "_side_wohoo_2", "_side_wohoo_3", "_side_yipee"]
    turboPlayWinAnimations = ["_side_turbo2_umpaaah", "_side_turbo2_wheew", "_side_turbo2_wohoo_1", "_side_turbo2_wohoo_2", "_side_turbo2_wohoo_3", "_side_turbo2_yipee"]

    constructor(leftX = config.logicalWidth * 0.25, rightX = config.logicalWidth * 0.75) {
        this.obstaclesContainer = new PIXI.Container();
        this.potholeContainer = new PIXI.Container();

        // this.obstacle = new SpineOld(PIXI.Assets.get('obstacles').spineData)
        this.obstacle = Spine.from({ skeleton: "obstacles", atlas: "obstaclesAtlas" });
        this.obstacle.x = config.logicalWidth / 2
        this.obstacle.y = config.logicalHeight * 0.62

        // this.potHoles = new SpineOld(PIXI.Assets.get('obstacles').spineData)
        this.potHoles = Spine.from({ skeleton: "obstacles", atlas: "obstaclesAtlas" });
        this.potHoles.x = config.logicalWidth / 2
        this.potHoles.y = config.logicalHeight * 0.62

        // this.nearMiss = new SpineOld(PIXI.Assets.get('oldMan').spineData)
        this.nearMiss = Spine.from({ skeleton: "oldMan", atlas: "oldManAtlas" });
        this.nearMiss.x = config.logicalWidth / 2
        this.nearMiss.y = config.logicalHeight * 0.62

        // this.nearMiss2 = new SpineOld(PIXI.Assets.get('obstacles').spineData)
        this.nearMiss2 = Spine.from({ skeleton: "obstacles", atlas: "obstaclesAtlas" });

        this.nearMiss2.x = config.logicalWidth / 2
        this.nearMiss2.y = config.logicalHeight * 0.62

        // this.obstaclesContainer.visible = false;
        // this.obstacle.visible = false;

        //this.obstacle.state.setAnimation(0, 'turtle_idle', true)
        //this.obstacle.scale.set(1);
        this.potholeContainer.addChild(this.potHoles, this.nearMiss2,this.nearMiss);
        this.obstaclesContainer.addChild(this.obstacle);
    }

    generateRandomNumber(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    generateObstacle(obstacleLane = globalData.obstacleLane) {
        const random = this.generateRandomNumber(0, this.idleAnimations.length - 1);
        this.potHoles.visible = true;
        globalData.nearMiss = false
        if (obstacleLane == "L") {

            this.obstacle.scale.set(1, 1)
            this.potHoles.scale.set(1, 1)
            this.nearMiss.scale.set(1, 1)
        }
        else if (obstacleLane == "R") {
            this.potHoles.scale.set(-1, 1)
            this.obstacle.scale.set(-1, 1)
            this.nearMiss.scale.set(-1, 1)
        }
        if (globalData.jeepneyLane === obstacleLane) {
            this.potholeContainer.removeChild(this.obstacle)
            this.obstaclesContainer.addChild(this.obstacle);
            this.obstacle.y = config.logicalHeight * 0.58
            if (random <= this.idleAnimations.length - 4) {
                this.obstacle.state.setAnimation(0, this.hitAnimations[random], false)
                setTimeout(() => {
                    this.playHitAnimation();
                    if (random === 0) playTrafficConeCrash();
                    else if (random === 1) playTrafficConeCrash();
                    else if (random === 2) playCrateCrash();
                    else if (random === 3) playTurtleCrash();
                }, 1000);
            } else {
                this.obstaclesContainer.removeChild(this.obstacle);
                this.potholeContainer.addChild(this.obstacle)
                this.potHoles.state.timeScale = 1;
                this.potHoles.state.setAnimation(0, this.potHoleAnimation[random - 4], false)
                setTimeout(() => {
                    this.playHitAnimation();
                    playPotHole1()
                }, 1000);
                setTimeout(() => {
                    this.potHoles.visible = false;
                    this.potHoles.state.timeScale = 100;

                }, 2020);
            }
        }
        else {
            if (this.generateRandomNumber(0, 6) < 1) {
                if (this.generateRandomNumber(0, 5) < 3) {
                    this.nearMiss.y = config.logicalHeight * 0.68
                    this.nearMiss.state.timeScale = 1.35
                    this.nearMiss.state.setAnimation(0, "old_man", false)
                    setTimeout(() => {
                        this.playWheewAnimation(true);
                        playJeepneyHonking()
                        playOldMan2();
                    }, 1000);
                    // playJeepneyHonking()
                } else {
                    if (obstacleLane == "L") {
                        this.nearMiss2.scale.set(-1, 1)
                    }
                    else if (obstacleLane == "R") {
                        this.nearMiss2.scale.set(1, 1)
                    }
                    setTimeout(() => {
                        playJeepReactionPhew2()
                    }, 650)
                    globalData.nearMiss = true
                    this.nearMiss2.y = config.logicalHeight * 0.68
                    this.nearMiss2.state.setAnimation(0, this.idleAnimations[this.generateRandomNumber(0, 2)], false)
                }
            } else {
                globalData.nearMiss = false
                this.obstacle.state.timeScale = 1.35
                this.obstacle.y = config.logicalHeight * 0.68
                this.obstacle.state.setAnimation(0, this.idleAnimations[random], false)
                setTimeout(() => {
                    this.playWheewAnimation();
                }, 1100);
            }
        }


    }
    playHitAnimation() {
        if (window.navigator.vibrate && globalData.vibration) {
            window.navigator.vibrate(200); // Vibrate for 100ms
        }
        const random = this.generateRandomNumber(0, 1)
        if (globalData.jeepneyLane === "L") {
            gameAssets.chicken.scale.set(1, 1)
            if (gameAssets.autoplayInprogress) {
                if (gameAssets.autoJeepney.visible) {
                    gameAssets.autoJeepney.state.setAnimation(0, 'L_side_hit', false)
                    //    gameAssets.autoChicken.scale.set(1, 1)
                    gameAssets.chicken.state.setAnimation(0, this.chickenAnimations[random], false)
                    //  gameAssets.autoChicken.state.setAnimation(0, this.chickenAnimations[random], false)
                } else {
                    gameAssets.turboJeepney.state.setAnimation(0, 'L_side_turbo2_hit', false);
                    //  gameAssets.turboChicken.scale.set(1, 1);
                    gameAssets.chicken.state.setAnimation(0, this.chickenAnimations[random], false)
                    //     gameAssets.turboChicken.state.setAnimation(0, this.chickenAnimations[random], false)

                }
            } else {
                gameAssets.jeepney.state.setAnimation(0, 'tuktuk_L_side_hit', false)

                gameAssets.chicken.state.setAnimation(0, this.chickenAnimations[random], false)
            }
            if (random) {
                PlayChickenSplat();
            } else {
                playChickenFall();
            }
            setTimeout(() => {
                if (globalData.jeepneyLane === "L") {
                    if (gameAssets.autoplayInprogress) {
                        if (gameAssets.autoJeepney.visible) {
                            gameAssets.autoJeepney.state.setAnimation(0, 'L_side', true)
                        } else {
                            //   showLeftJeepney()
                            gameAssets.turboJeepney.state.setAnimation(0, 'L_side_turbo2', true)
                        }
                    } else {
                        gameAssets.jeepney.state.setAnimation(0, 'tuktuk_L_side', true)
                    }
                }
                else {
                    if (gameAssets.autoplayInprogress) {
                        if (gameAssets.autoJeepney.visible) {
                            gameAssets.autoJeepney.state.setAnimation(0, 'R_side', true)
                        } else {
                            //     showRightJeepney();
                            gameAssets.turboJeepney.state.setAnimation(0, 'R_side_turbo2', true)
                        }
                    } else {
                        gameAssets.jeepney.state.setAnimation(0, 'tuktuk_R_side', true)
                    }
                }
            }, 850);
        }
        else if (globalData.jeepneyLane === "R") {
            gameAssets.chicken.scale.set(-1, 1)
            if (gameAssets.autoplayInprogress) {
                if (gameAssets.autoJeepney.visible) {
                    gameAssets.autoJeepney.state.setAnimation(0, 'R_side_hit', false);
                    //   gameAssets.autoChicken.scale.set(-1, 1)
                    //    gameAssets.autoChicken.state.setAnimation(0, this.chickenAnimations[random], false)
                    gameAssets.chicken.state.setAnimation(0, this.chickenAnimations[random], false)
                } else {
                    gameAssets.turboJeepney.state.setAnimation(0, 'R_side_turbo2_hit', false)
                    //   gameAssets.turboChicken.scale.set(-1, 1);
                    //     gameAssets.turboChicken.state.setAnimation(0, this.chickenAnimations[random], false)
                    gameAssets.chicken.state.setAnimation(0, this.chickenAnimations[random], false)
                }

            } else {
                gameAssets.jeepney.state.setAnimation(0, 'tuktuk_R_side_hit', false)
                gameAssets.chicken.state.setAnimation(0, this.chickenAnimations[random], false)
            }
            if (random) {
                PlayChickenSplat();
            } else {
                playChickenFall();
            }
            setTimeout(() => {
                if (globalData.jeepneyLane === "R") {
                    if (gameAssets.autoplayInprogress) {
                        if (gameAssets.autoJeepney.visible) {
                            gameAssets.autoJeepney.state.setAnimation(0, 'R_side', true)
                        } else {
                            //  showRightJeepney()
                            gameAssets.turboJeepney.state.setAnimation(0, 'R_side_turbo2', true)
                        }
                    } else {
                        gameAssets.jeepney.state.setAnimation(0, 'tuktuk_R_side', true)
                    }
                }
                else {
                    if (gameAssets.autoplayInprogress) {
                        if (gameAssets.autoplayInprogress) {
                            gameAssets.autoJeepney.state.setAnimation(0, 'L_side', true)
                        } else {
                            //   showLeftJeepney()
                            gameAssets.turboJeepney.state.setAnimation(0, 'L_side_turbo2', true)
                        }
                    } else {
                        gameAssets.jeepney.state.setAnimation(0, 'tuktuk_L_side', true)
                    }
                }
            }, 850);
        }
    }

    playWheewAnimation(sound = false) {
        let randomNum = this.generateRandomNumber(0, 5);
        let time = 800;
        if (!sound) {
            const random = this.generateRandomNumber(0, 3)
            switch (random) {
                case 0:
                    playJeepReactionWoohoo();
                    break;
                case 1:
                    playJeepReactionUmPaa();
                    break;
                case 2:
                    playJeepReactionYiepie();
                    break;
                case 3:
                    playJeepReactionYii();
                    break;
            }
        }
        if (globalData.jeepneyLane === "L") {
            if (gameAssets.autoplayInprogress) {
                if (randomNum !== 1) time = 800;
                if(gameAssets.autoJeepney.visible){
                  gameAssets.autoJeepney.state.setAnimation(0, 'L'+this.autoPlayWinAnimations[randomNum], false)
                } else {
                    gameAssets.turboJeepney.state.setAnimation(0, 'L'+this.turboPlayWinAnimations[randomNum], false)
                }
            } else {
                gameAssets.jeepney.state.setAnimation(0, 'tuktuk_L_side_wheew', false)
            }

            setTimeout(() => {
                if (globalData.jeepneyLane === "L") {
                    if (gameAssets.autoplayInprogress) {
                        if (gameAssets.autoJeepney.visible) {
                            gameAssets.autoJeepney.state.setAnimation(0, 'L_side', true)
                        } else {
                            //  showLeftJeepney()
                            gameAssets.turboJeepney.state.setAnimation(0, 'L_side_turbo2', true)
                        }
                    } else {
                        gameAssets.jeepney.state.setAnimation(0, 'tuktuk_L_side', true)
                    }
                }

                else {
                    if (gameAssets.autoplayInprogress) {
                        if (gameAssets.autoJeepney.visible) {
                            gameAssets.autoJeepney.state.setAnimation(0, 'R_side', true)
                        } else {
                            gameAssets.autoJeepney.state.setAnimation(0, 'R_side', true)
                        }
                    } else {
                        gameAssets.jeepney.state.setAnimation(0, 'tuktuk_R_side', true)
                    }
                }
            }, time);
        }
        else if (globalData.jeepneyLane === "R") {
            if (gameAssets.autoplayInprogress) {
                if (randomNum !== 1) time = 800;
                  if(gameAssets.autoJeepney.visible){
                    gameAssets.autoJeepney.state.setAnimation(0, 'R'+this.autoPlayWinAnimations[randomNum], false)
                  } else {
                    gameAssets.turboJeepney.state.setAnimation(0, 'R'+this.turboPlayWinAnimations[randomNum], false)
                  }
            } else {
                gameAssets.jeepney.state.setAnimation(0, 'tuktuk_R_side_wheew', false)
            }
            setTimeout(() => {
                if (globalData.jeepneyLane === "R") {
                    if (gameAssets.autoplayInprogress) {
                        if (gameAssets.autoJeepney.visible) {
                            gameAssets.autoJeepney.state.setAnimation(0, 'R_side', true)
                        } else {
                            //  showRightJeepney()
                            gameAssets.turboJeepney.state.setAnimation(0, 'R_side_turbo2', true)
                        }
                    } else {
                        gameAssets.jeepney.state.setAnimation(0, 'tuktuk_R_side', true)
                    }
                }
                else {
                    if (gameAssets.autoplayInprogress) {
                        if (gameAssets.autoJeepney.visible) {
                            gameAssets.autoJeepney.state.setAnimation(0, 'L_side', true)
                        } else {
                            // showLeftJeepney()
                            gameAssets.turboJeepney.state.setAnimation(0, 'L_side_turbo2', true)
                        }
                    } else {
                        gameAssets.jeepney.state.setAnimation(0, 'tuktuk_L_side', true)
                    }
                }
            }, time);
        }
    }
    checkCrash(obstaclePos) {

        if (globalData.jeepneyLane === obstaclePos) {
            //  this.obstacle = null;
            return true;
        }
        else {
            //  this.obstacle = null;
            return false
        }
    }
}